import Message from '../../components/message/message';
import axios from 'axios';
import {clearUser, goLogin} from './util';

const ERR_OK = '200';
const ERR_TIME_OUT = '4';

const message = new Message();

export default function fetch2(code, param) {
    // const url = '/api' + code;
    const url = '/api' + '/core' + code;

    const data = {
        ...param
    };

    param = JSON.stringify(data);
    let locale = window.localStorage.getItem('user_lang');
    return axios({
        method: 'GET',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': localStorage.getItem('token') || '',
            'Accept-Language': locale === 'en' ? 'en_US' : 'zh_CN'
        },
        url: url,
        data: param
    }).then((res) => {
        res = res.data;
        if (res.errorCode === ERR_TIME_OUT) {
            message.show('Login timed out. Please log in again');
            clearUser();
            setTimeout(() => {
                goLogin();
            }, 800);
            return Promise.reject('timeout');
        }else if (res.errorCode === 'A50004') {
            message.show('Login timed out. Please log in again');
            clearUser();
            setTimeout(() => {
                goLogin();
            }, 800);
            return Promise.reject('timeout');
        }else if(res.errorCode === 'CORE00033'){
            message.show(res.errorMsg);
            return Promise.reject(res);
        }
        if (res.code && res.code !== ERR_OK) {
            let d = localStorage.getItem('token');
            if (!d) {
                // message.show('Please Log in');
            } else if (res.errorInfo) {
                // message.show(res.errorCode || 'Server Error');
            } else if (res.errorMsg) {
                // message.show(res.errorCode || 'Server Error');
            } else {
                // message.show(res.errorCode || 'Server Error');
            }
            // return Promise.reject(res.errorInfo);
            return Promise.reject(res);
        }
        const data = (res.data != null) ? res.data : res;
        return Promise.resolve(data);
    });
}
